import { extractAriaAttributes } from './extractAriaAttributes';
import { extractDataAttributes } from './extractDataAttributes';
import { extractBaseInputComponentProps, } from './extractBaseInputComponentProps';
/** Extracts properties in several objects:
 *  - rootElementAttributes: e.g. style, id, className
 *    to be applied to the root element of the component
 *  - baseInputComponentProps: part of BaseFormInputComponentProps.
 *    e.g. size, inputProps, status props like success, error, ..
 *    to be used inside the component and act upon them
 *  - baseHtmlInputAttributes: part of BaseFormInputComponentProps
 *    e.g. disabled, readOnly, required
 *  - ariaAttributes: e.g. aria-describedby
 *  - dataAttributes: whatever custom data-* attribute
 *  - restProps: all the rest. Which means:
 *    1. the specific props of a component
 *    2. the html attributes (InputHTMLAttributes<HTMLInputElement>) that you might added to the Props type
 *    You should destructure these in the component into the specifics and ...restInputProps,
 *    using the specifics and passing the restInputProps to the actual input element
 * */
export function extractPropsForInputComponent(props) {
    var _a = extractBaseInputComponentProps(props), baseInputComponentProps = _a.baseInputComponentProps, rootElementAttributes = _a.rootElementAttributes, baseHtmlInputAttributes = _a.baseHtmlInputAttributes, rest1 = _a.restProps;
    var _b = extractAriaAttributes(rest1), ariaAttributes = _b.ariaAttributes, rest2 = _b.restProps;
    var _c = extractDataAttributes(rest2), dataAttributes = _c.dataAttributes, restProps = _c.restProps;
    return {
        rootElementAttributes: rootElementAttributes,
        baseInputComponentProps: baseInputComponentProps,
        baseHtmlInputAttributes: baseHtmlInputAttributes,
        ariaAttributes: ariaAttributes,
        dataAttributes: dataAttributes,
        // todo fix typing?
        restProps: restProps,
    };
}
//# sourceMappingURL=extractPropsForInputComponent.js.map